module.exports = __webpack_public_path__ + "static/media/p2s.4d9b0357.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/p2s.png
// module id = 82
// module chunks = 0